import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Clock, AlertTriangle } from 'lucide-react';
export function OpeningHook() {
  return <section className="py-20 relative border-t border-slate-800/50 bg-[#0d1322]" data-id="element-130">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
        <FadeIn data-id="element-132">
          <div className="bg-[#111827] border border-slate-800 rounded-2xl p-8 md:p-12 shadow-xl relative overflow-hidden" data-id="element-133">
            <div className="absolute top-0 left-0 w-1 h-full bg-red-500/50" data-id="element-134" />

            <div className="flex items-center gap-4 mb-6 text-red-400" data-id="element-135">
              <Clock className="w-8 h-8" data-id="element-136" />
              <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-137">
                Son las 8:00 PM de un domingo.
              </h2>
            </div>

            <div className="space-y-6 text-lg md:text-xl text-[#d1d5db] leading-relaxed" data-id="element-138">
              <p data-id="element-139">
                Miras tu bandeja de entrada y sientes ese nudo en el estómago.
                Sabes que mañana te espera una montaña de correos, reportes
                infinitos y reuniones que pudieron ser un mensaje.
              </p>
              <p data-id="element-140">
                Estás cansado de{' '}
                <span className="text-white font-semibold" data-id="element-141">"dar el 110%"</span>.
                Estás harto de que tu tiempo libre se consuma pensando en
                pendientes que una máquina debería estar haciendo por ti.
              </p>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} className="mt-16" data-id="element-142">
          <div className="flex items-center gap-3 mb-6" data-id="element-143">
            <AlertTriangle className="w-6 h-6 text-cyan-400" data-id="element-144" />
            <h3 className="text-2xl font-bold text-white" data-id="element-145">
              El problema no es que tengas mucho trabajo.
            </h3>
          </div>
          <p className="text-xl text-cyan-400 font-medium mb-6" data-id="element-146">
            El problema es que sigues trabajando como si estuviéramos en el
            2010.
          </p>
          <p className="text-lg text-[#d1d5db] leading-relaxed" data-id="element-147">
            Pasas horas redactando correos "profesionales", peleando con tablas
            de Excel que no te dicen nada y tomando notas en reuniones donde
            nadie llega a una conclusión. Intentaste usar la IA, pero lo que te
            devuelve suena robótico, genérico o simplemente no sirve para tu día
            a día corporativo.
          </p>
        </FadeIn>
      </div>
    </section>;
}